import { TFunction } from "i18next";
import { openErrorMessage } from "../store/message/messageSlice";
import { AppDispatch } from "../store/store";

export const handleError = (e: any, dispatch: AppDispatch, t: TFunction) => {
  if (e.response?.data?.reason || e?.response?.reason || e?.reason) {
    dispatch(openErrorMessage(t(e.response.data.reason)));
  } else {
    dispatch(openErrorMessage(t("SOMETHING_WENT_WRONG")));
  }
};
